import { useNavigate } from 'react-router-dom';

import { useFetch, useFetchOne } from '../../../hooks/useFetch';
import { API_ENDPOINTS, POPULATE_PARAMS } from '../../../config/constants';
import Loading from '../../../components/common/Loading';
import ErrorMessage from '../../../components/common/ErrorMessage';

const VisionMission = () => {
    const navigate = useNavigate();

    const { data: post, loading, error } = useFetch(API_ENDPOINTS.MISSION_VISION, POPULATE_PARAMS.ONE_WITH_IMAGES);
    //console.log(post)
    if (loading) return <Loading />;
    if (error) return <ErrorMessage message={error} />;
    if (!post) {
        return (
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <ErrorMessage message="İçerik bulunamadı" />
                <div className="text-center mt-8">
                    <button
                        onClick={() => navigate(-1)}
                        className="px-8 py-4 bg-blue-900 text-white rounded font-semibold hover:bg-blue-800 transition-colors"
                    >
                        ← Geri Dön
                    </button>
                </div>
            </div>
        );
    }
    return (
        <section className="w-full py-10 bg-gray-50 text-gray-800">
            <div className="max-w-7xl mx-auto px-4 md:px-8">

                {/* Section Header */}
                <div className="text-center mb-8 space-y-4">
                    <div className="inline-block px-3 py-1 bg-[#005aab]/10 text-[#005aab] text-sm font-semibold rounded-full mb-2">
                        {post.mini_title}
                    </div>
                    <h2 className="text-3xl md:text-4xl font-bold text-[#005aab]">
                        {post.title}

                    </h2>
                    <div className="w-24 h-1 bg-[#005aab] mx-auto rounded-full" />
                    {/* <p className="max-w-2xl mx-auto text-gray-500 text-lg mt-4">
                        
                    </p> */}
                </div>

                {/* Content Grid */}
                <div className="grid md:grid-cols-2 gap-8 lg:gap-12">

                    {/* --- VISION CARD --- */}
                    <div className="group bg-white rounded-xl p-8 border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 relative overflow-hidden">
                        {/* Decorative Top Line */}
                        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-gray-200 to-transparent group-hover:from-[#005aab] group-hover:to-[#005aab] transition-all duration-500" />

                        <div className="flex items-start gap-6">
                            {/* Icon */}
                            <div className="shrink-0 w-14 h-14 bg-[#005aab]/5 text-[#005aab] rounded-lg flex items-center justify-center group-hover:bg-[#005aab] group-hover:text-white transition-colors duration-300">
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                                </svg>
                            </div>
                            {/* Text Content */}
                            <div>
                                <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-[#005aab] transition-colors">
                                    Misyonumuz
                                </h3>
                                <p className="text-gray-600 leading-relaxed text-justify">
                                    {post.misyon}
                                </p>
                            </div>

                        </div>
                    </div>

                    {/* --- MISSION CARD --- */}
                    <div className="group bg-white rounded-xl p-8 border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 relative overflow-hidden">
                        {/* Decorative Top Line */}
                        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-gray-200 to-transparent group-hover:from-[#005aab] group-hover:to-[#005aab] transition-all duration-500" />

                        <div className="flex items-start gap-6">
                            {/* Icon */}

                            <div className="shrink-0 w-14 h-14 bg-[#005aab]/5 text-[#005aab] rounded-lg flex items-center justify-center group-hover:bg-[#005aab] group-hover:text-white transition-colors duration-300">
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>
                            </div>

                            {/* Text Content */}
                            <div>
                                <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-[#005aab] transition-colors">
                                    Vizyonumuz
                                </h3>
                                <p className="text-gray-600 leading-relaxed text-justify">
                                    {post.vizyon}
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default VisionMission;